import React from 'react';

import {PreviousMeetingsWidgetProps} from "../models/previous-meetings-widget.props";
import {EntityLogo, EntityLogoProps} from "../../../core/components/logos/entity-logo";
import {EntityViewModel} from "../../../infrastructure/models/entity/entity.view-model";
import {EntityDisplayName} from "../../../core/components/entity-display-name";
import {ACTION_TYPES} from "../../../core/consts";
import {Link} from "../../../core/components/link/link";
import {APP, SPORT_TYPES} from "../../../core/app/consts";
import {CompetitorViewModel} from "../../../domain/common/competitor/models/competitor-view-model";
import {observer} from "mobx-react";
import styles from "../styles/previous-meetings-widget.module.scss";
import classNames from "classnames";

export class PreviousMeetingsWidgetCompetitorDetailsProps extends PreviousMeetingsWidgetProps {
  isHomeTeam: Boolean;
}

export const PreviousMeetingsWidgetCompetitorDetails = observer(({
                                                                   controller,
                                                                   isHomeTeam,
                                                                   competitorLinkModel
                                                                 }: PreviousMeetingsWidgetCompetitorDetailsProps) => {
  const {state, device} = controller;
  const {currentLinkModel, homeCompetitor, awayCompetitor} = state
  const entity: EntityViewModel = isHomeTeam ? homeCompetitor : awayCompetitor;

  const onCompetitorClick = () => {
    controller.action(ACTION_TYPES.entityClick, {
      entityId: competitorLinkModel.params.id,
      entityType: APP.ANALYTICS.ENTITY_DISPLAY_TYPES[CompetitorViewModel.name],
      source: APP.ANALYTICS.SOURCES[currentLinkModel.name],
      currentLinkModel: currentLinkModel,
      sportTypeId: SPORT_TYPES[competitorLinkModel.params.sportName]
    });

    return true;
  };

  const linkProps = {
    model: competitorLinkModel,
    onClick: () => onCompetitorClick()
  };

  const entityLogoProps: EntityLogoProps = {
    width: !device.isLargeView ? 40 : 55,
    height: !device.isLargeView ? 40 : 55,
    entity
  };

  return (
    <div className={classNames(styles.competitor_details_container)}>
      <div className={classNames(styles.competitor_details_logo)}>
        <Link {...linkProps}>
          <EntityLogo {...entityLogoProps}/>
        </Link>
      </div>
      <div className={classNames(styles.competitor_details_name)}>
        <EntityDisplayName entity={entity} numOfMaxLines={2}/>
      </div>
    </div>
  );
});
